module.exports = __webpack_public_path__ + "f16c378b3bb00370b66bec51dca8cec9.MP3";